(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
